export const CLEAR_RESULTS = `CLEAR_RESULTS`;

export const clearResults = (current) => ({
  type: CLEAR_RESULTS,
  current,
});
